module.exports = "<canvas #c class=\"mainCanvas\" ></canvas>\n"